"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountTypes = void 0;
var DiscountTypes;
(function (DiscountTypes) {
    DiscountTypes["QUANTITATIVE"] = "quantitative";
    DiscountTypes["ON_REVENUE"] = "revenue";
    DiscountTypes["SIMPLE"] = "simple";
})(DiscountTypes = exports.DiscountTypes || (exports.DiscountTypes = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGlzY291bnRUeXBlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9EaXNjb3VudFR5cGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksYUFJWDtBQUpELFdBQVksYUFBYTtJQUN2Qiw4Q0FBNkIsQ0FBQTtJQUM3Qix1Q0FBc0IsQ0FBQTtJQUN0QixrQ0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBSlcsYUFBYSxHQUFiLHFCQUFhLEtBQWIscUJBQWEsUUFJeEIifQ==